"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * RichWise_Website_API.API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.instanceOfRoleListSearchModel = instanceOfRoleListSearchModel;
exports.RoleListSearchModelFromJSON = RoleListSearchModelFromJSON;
exports.RoleListSearchModelFromJSONTyped = RoleListSearchModelFromJSONTyped;
exports.RoleListSearchModelToJSON = RoleListSearchModelToJSON;
exports.RoleListSearchModelToJSONTyped = RoleListSearchModelToJSONTyped;
/**
 * Check if a given object implements the RoleListSearchModel interface.
 */
function instanceOfRoleListSearchModel(value) {
    return true;
}
function RoleListSearchModelFromJSON(json) {
    return RoleListSearchModelFromJSONTyped(json, false);
}
function RoleListSearchModelFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'orderString': json['orderString'] == null ? undefined : json['orderString'],
        'currentPage': json['currentPage'] == null ? undefined : json['currentPage'],
        'pageSize': json['pageSize'] == null ? undefined : json['pageSize'],
        'ugNo': json['ugNo'] == null ? undefined : json['ugNo'],
    };
}
function RoleListSearchModelToJSON(json) {
    return RoleListSearchModelToJSONTyped(json, false);
}
function RoleListSearchModelToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'orderString': value['orderString'],
        'currentPage': value['currentPage'],
        'pageSize': value['pageSize'],
        'ugNo': value['ugNo'],
    };
}
